<template>
  <div class="container">
    <div
      ref="contract"
      class="box service-contract-box"
      @scroll="event => handleScroll(event.target)"
    >
      <h4 class="title is-6 has-text-centered">
        TERMO DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS PARA USO DA PLATAFORMA ELETRÔNICA DE LICITAÇÕES
        CORPORATIVAS – SELCORP
      </h4>

      <div class="owner-info" :class="{ 'justify-align': justify }">
        <span>
          Pelo presente instrumento particular de contrato de prestação de serviços para uso da
          plataforma eletrônica de licitações corporativas, entre os signatários, de um lado
          nomeado(a) e qualificado(a) na própria plataforma, no ambiente de CADASTRO, doravante aqui
          simplesmente designado(a) LICITANTE, e, de outro lado, SELCORP LICITAÇÕES S/A, com sede na
          cidade de São Paulo, Estado de São Paulo, na Rua Augusta nº 1.168 – 2º andar – Consolação,
          inscrita no CNPJ/MF sob o nº 29.945.708/0001-05, aqui doravante simplesmente designada
          CONTRATADA, têm entre si, justo e contratado o que segue e que mutuamente outorgam e
          aceitam, a saber:
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA PRIMEIRA</h6>
      <div class="first-clause" :class="{ 'justify-align': justify }">
        <span>
          Por meio do presente termo, a LICITANTE manifesta sua vontade de contratar e obter acesso
          ao Sistema Eletrônico de Licitações Corporativas - SELCORP, do qual declara ter pleno
          conhecimento, em conformidade com as disposições que seguem.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA SEGUNDA</h6>
      <div class="content second-clause" :class="{ 'justify-align': justify }">
        <span class="second-clause-span">São responsabilidades do Licitante:</span>
        <ol type="a">
          <li>
            tomar conhecimento e cumprir todos os dispositivos constantes dos editais de licitações
            promovidas pelo órgão promotor da licitação através do Sistema Eletrônico de Licitações
            Corporativas – SELCORP dos processos dos quais venha a participar;
          </li>
          <li>
            observar e cumprir a regularidade fiscal, apresentando a documentação exigida nos
            editais para fins de habilitação nas licitações em que for vencedor;
          </li>
          <li>
            observar a legislação pertinente, bem como o disposto nas demais normas e regulamentos
            publicados no site da SELCORP dos quais declara ter pleno conhecimento;
          </li>
          <li>
            designar representante responsável para operar o Sistema Eletrônico de Licitações
            Corporativas – SELCORP que será detentor de login e senha de acesso conforme Anexo I
            deste termo;
          </li>
          <li>
            pagar o valor correspondente ao plano escolhido referente à taxa pela utilização do
            Sistema Eletrônico de Licitações Corporativas.
          </li>
        </ol>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA TERCEIRA</h6>
      <div class="content third-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">O Licitante reconhece que:</span>
        <ol type="a">
          <li>
            a Senha e a Chave Eletrônica de identificação do usuário para acesso ao sistema são de
            uso exclusivo de seu titular, não cabendo à SELCORP ou ao órgão promotor da licitação
            nenhuma responsabilidade por eventuais danos ou prejuízos decorrentes de seu uso
            indevido;
          </li>
          <li>
            a exclusão de Senha ou de Chave Eletrônica poderá ser feita pela SELCORP mediante
            solicitação escrita do representante legal do Licitante;
          </li>
          <li>
            a perda de Senha ou de Chave Eletrônica ou a quebra de seu sigilo deverá ser comunicada
            imediatamente à SELCORP para o necessário bloqueio de acesso;
          </li>
          <li>
            o Licitante será responsável por todas as propostas, lances de preços e transações
            efetuadas no sistema, por seu usuário, por sua conta e ordem, assumindo-os como firmes e
            verdadeiros.
          </li>
        </ol>
      </div>

      <h6 class="subtitle is-6 margin-1">
        CLÁUSULA QUARTA – LIMITAÇÃO DE RESPONSABILIDADE DA CONTRATADA
      </h6>
      <div class="content fourth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          A CONTRATADA não será responsável por falhas técnicas, interrupções de serviço, perda de
          dados, erros de sistema ou qualquer evento decorrente de caso fortuito, força maior,
          manutenção programada, falha de terceiros (inclusive provedores de internet e energia) ou
          atos do próprio LICITANTE. Em nenhuma hipótese a responsabilidade da CONTRATADA excederá
          os valores pagos pelo LICITANTE nos últimos 12 (doze) meses anteriores ao evento.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA QUINTA</h6>
      <div class="content fifth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          O Licitante outorga plenos poderes ao(s) representante(s) legal(is) que indicar na forma
          desse termo, para:
        </span>
        <ol type="a">
          <li>declarar que conhece e atende as condições de habilitação previstas nos Editais;</li>
          <li>apresentar lances de preço;</li>
          <li>apresentar manifestação sobre os procedimentos adotados pelo pregoeiro;</li>
          <li>solicitar informações via sistema eletrônico;</li>
          <li>interpor recursos contra atos do pregoeiro;</li>
          <li>apresentar e retirar documentos;</li>
          <li>solicitar e prestar declarações e esclarecimentos;</li>
          <li>assinar documentos relativos às propostas; e</li>
          <li>
            praticar todos os atos em direito admitidos para o bom e fiel cumprimento do presente
            mandato, que não poderá ser substabelecido.
          </li>
        </ol>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA SEXTA – SUSPENSÃO DOS SERVIÇOS</h6>
      <div class="content sixth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          A CONTRATADA poderá suspender temporariamente a prestação dos serviços, total ou
          parcialmente, em razão de caso fortuito, força maior, determinação legal ou judicial,
          manutenção programada, desde que comunique previamente o LICITANTE, salvo em situações
          emergenciais.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA SÉTIMA – ATUALIZAÇÃO CONTRATUAL</h6>
      <div class="content seventh-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          A CONTRATADA poderá alterar as condições deste contrato, mediante comunicação prévia ao
          LICITANTE, por e-mail e/ou aviso no sistema, com antecedência mínima de 10 (dez) dias,
          sendo facultado ao LICITANTE rescindir o contrato caso não concorde com as novas
          condições.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA OITAVA – PROTEÇÃO DE DADOS PESSOAIS (LGPD)</h6>
      <div class="content eighth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          A CONTRATADA se compromete a observar integralmente as disposições da Lei Geral de
          Proteção de Dados (Lei nº 13.709/2018 – LGPD), garantindo o tratamento adequado dos dados
          pessoais do LICITANTE para fins de execução deste contrato, adotando todas as medidas de
          segurança exigidas em lei.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA NONA – REAJUSTE DE VALORES</h6>
      <div class="content ninth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          Os valores previstos neste contrato poderão ser reajustados anualmente, a partir da
          assinatura, com base na variação do IPCA/IBGE ou outro índice oficial que venha a
          substituí-lo, mediante aviso prévio de 15 (quinze) dias.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA DÉCIMA – CESSÃO E TRANSFERÊNCIA</h6>
      <div class="content tenth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          Nenhuma das partes poderá ceder ou transferir, total ou parcialmente, os direitos e
          obrigações decorrentes deste contrato sem o consentimento prévio e por escrito da outra
          parte.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">
        CLÁUSULA DÉCIMA PRIMEIRA– CANAIS DE COMUNICAÇÃO E NOTIFICAÇÕES
      </h6>
      <div class="content eleventh-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          As comunicações e notificações relativas a este contrato deverão ser realizadas por meio
          do endereço eletrônico cadastrado no sistema ou outro canal indicado pelas partes.
        </span>
      </div>

      <h6 class="subtitle is-6 margin-1">CLÁUSULA DÉCIMA SEGUNDA – FORO E LEI APLICÁVEL</h6>
      <div class="content twelfth-clause" :class="{ 'justify-align': justify }">
        <span class="clause-span">
          Fica eleito o Foro da Comarca de São Paulo/SP para dirimir quaisquer controvérsias
          oriundas deste contrato, com renúncia de qualquer outro, por mais privilegiado que seja,
          aplicando-se a legislação brasileira.
        </span>
      </div>

      <div class="declaration-bidder" :class="{ 'justify-align': justify }">
        <p>São Paulo, 03 de julho de 2025 – Brasil.</p>
      </div>
      <h4 class="title is-6 has-text-centered">
        ANEXO I AO TERMO DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS PARA USO DA PLATAFORMA ELETRÔNICA DE
        LICITAÇÕES CORPORATIVAS - SELCORP
      </h4>
      <h4 class="title is-6 has-text-centered">CUSTO PELA UTILIZAÇÃO DO SISTEMA</h4>

      <div class="attachment-one indentation-1" :class="{ 'justify-align': justify }">
        <p>
          A cobrança pela utilização do Sistema Eletrônico de Licitações Corporativas – SELCORP será
          realizada apenas ao Licitante que optar por participar de licitação pública aberta para
          inserção de propostas, em qualquer modalidade das licitações eletrônicas processadas neste
          sistema.
        </p>
        <p>
          O valor dos custos, pela utilização do sistema privado de licitações devidamente previsto
          no parágrafo 1º do Artigo 175, da Lei Federal nº 14.133/2021, está definido conforme os
          planos disponíveis abaixo e apresentados publicamente na plataforma da CONTRATADA:
        </p>

        <ol type="1">
          <li class="spacing-half">
            <strong>PLANOS COM PERIODICIDADE</strong><br />
            Trimestral R$ 567,00<br />
            Semestral R$ 999,00<br />
            Anual R$ 1.550,00
          </li>
          <li class="spacing-half">
            <strong>CRÉDITOS AVULSOS</strong><br />
            1 crédito R$ 158,00<br />
            5 créditos R$ 790,00<br />
            10 créditos R$ 1.580,00
          </li>
        </ol>

        <p><strong>Formas de Pagamento e Prazos de Compensação</strong></p>
        <p>
          O pagamento das taxas de utilização do sistema poderá ser efetuado por boleto bancário,
          cartão de crédito ou Pix.
        </p>
        <p>
          Atenção: O pagamento por boleto bancário está sujeito a prazo de compensação bancária de
          até 48 horas úteis. Para participação em licitações com encerramento previsto dentro desse
          período, recomenda-se a utilização do Pix ou do cartão de crédito, cuja compensação ocorre
          em até 2 horas, garantindo assim a liberação do acesso e evitando o risco de perda do
          prazo para inserção de propostas.
        </p>

        <p><strong>Observações importantes:</strong></p>
        <ul>
          <li>
            O sistema permitirá ao LICITANTE, mesmo com um plano ativo (trimestral, semestral ou
            anual), adquirir créditos avulsos adicionais.
          </li>
          <!-- <li>
            Entretanto, ao inserir uma proposta com créditos disponíveis, o sistema consumirá 1 (um)
            crédito, mesmo que o plano esteja ativo.
          </li> -->
          <li>
            A escolha da forma de cobrança e contratação do plano é de responsabilidade do
            LICITANTE, que deverá realizá-la em seu perfil no sistema.
          </li>
        </ul>

        <p>
          A vigência deste contrato tem início na data de confirmação do pagamento do plano
          selecionado pelo LICITANTE, conforme registro eletrônico no sistema SELCORP, e será
          automaticamente renovada a cada novo pagamento, conforme opção escolhida pelo LICITANTE no
          momento da contratação.
        </p>

        <p>
          Disposições Finais<br />
          Os contratos firmados anteriormente à presente data permanecem regidos pelas cláusulas e
          condições do instrumento contratual vigente à época de sua celebração, não sendo
          automaticamente alcançados pelas disposições do presente contrato.
        </p>
      </div>

      <div class="notice-possible-change">
        <p><b>*Contrato sujeito a alterações sem aviso prévio.</b></p>
      </div>
    </div>

    <div class="service-contract-form-container">
      <div class="service-contract-download">
        <a download :href="fileServer('contrato.pdf', 'files')" target="_blank">
          Baixe aqui o contrato entre a sua empresa e a SelCorp</a
        >
      </div>

      <form @keyup.enter="registrationCompany">
        <b-field
          class="service-contract-field"
          :type="campoInvalido('accepted', 'contract') ? 'is-danger' : ''"
          :message="
            campoInvalido('accepted', 'contract')
              ? 'Você deve concordar com os termos do contrato de serviço'
              : ''
          "
        >
          <div class="service-contract-checkbox-container">
            <b-checkbox
              class="service-contract-checkbox"
              v-model="$v.contract.accepted.$model"
              :disabled="disableElements"
              >Concordo com os termos do contrato de serviço.
            </b-checkbox>

            <b-tooltip
              v-if="displayHelpTooltip"
              label="Leia todo o contrato"
              position="is-top"
              size="is-medium"
              ><b-icon class="custom-help" icon="help-circle" type="is-primary"></b-icon>
            </b-tooltip>
          </div>
        </b-field>

        <b-button
          expanded
          type="is-primary"
          :loading="loading"
          @click.prevent.stop="acceptServiceContract()"
        >
          Continuar
        </b-button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import field from '@/mixins/formulario';
import { fileServer } from '@/utils/functions';

export default {
  name: 'ServiceContract',
  mixins: [field],
  data() {
    const contract = {
      accepted: null,
    };

    return {
      contract,
      fileServer,
      loading: false,
      disableElements: true,
    };
  },
  validations: {
    contract: {
      accepted: { required },
    },
  },
  computed: {
    ...mapState('app', ['windowWidth']),
    ...mapState('companies', ['company']),
    ...mapGetters('app', { mobile: 'mobile' }),
    displayHelpTooltip() {
      return this.windowWidth > 576;
    },
    justify() {
      return this.windowWidth > 960;
    },
  },
  methods: {
    ...mapActions('companies', ['acceptCompanyServiceContract']),
    async acceptServiceContract() {
      if (this.validate()) {
        this.loading = true;
        try {
          await this.acceptCompanyServiceContract({ companyId: this.company.id });
          this.$alerta('Contrato de serviço aceito', 'is-success');
          this.$router.push({ name: 'CompanyValidation', params: { id: this.company.id } });
        } catch (error) {
          this.$alerta(error.message, 'is-danger');
        }
        this.loading = false;
      }
    },
    handleScroll(contract) {
      if (contract.scrollHeight - contract.scrollTop <= contract.clientHeight + 50) {
        this.disableElements = false;
      }
    },
    validate() {
      if (this.$v.contract.$invalid || !this.contract.accepted) {
        this.contract.accepted = null;
        this.$v.contract.$touch();
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-one {
  margin-bottom: 2rem;
}

.clause-span {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.clause-span {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.declaration-bidder {
  margin-top: 3rem;
  margin-bottom: 1rem;
}

.declaration-state {
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.justify-align {
  text-align: justify;
}

.indentation-one-half {
  margin-left: 1.5rem;
}

.indentation-1 {
  margin-left: 1rem;
}

.indentation-2 {
  margin-left: 2rem;
}

.margin-1 {
  margin: 1.5rem 0;
}

.notice-possible-change {
  margin-top: 3rem;
}

ol li {
  text-indent: 0.4rem;
}

.service-contract-box {
  height: 270px;
  overflow: hidden;
  overflow-y: auto;
}

.subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #444;
  margin: 1rem 0 0.5rem;
}

.service-contract-checkbox {
  display: flex !important;
}

.service-contract-checkbox-container {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 25px;
  display: flex;
  justify-content: space-between;
}

.service-contract-field {
  margin-top: 1rem;
  margin-bottom: 1.5rem !important;
}

.service-contract-form-container {
  margin-top: 2rem;
}

.spacing {
  margin-bottom: 1rem;
}

.spacing-half {
  margin-bottom: 0.5rem;
}

@media (min-width: 1500px) {
  .service-contract-box {
    height: 350px;
  }
}
</style>
